import { Injectable, OnDestroy } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, BehaviorSubject, interval, Subscription } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class InternetMonitorService implements OnDestroy {
  private internetConnectionSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  public internetConnection$: Observable<boolean> = this.internetConnectionSubject.asObservable();

  private SERVER_URL = 'http://localhost:3500';
  private internetCheckUrl = 'https://httpbin.org/status/200';
  private monitoringInterval = 10000; // 10 seconds
  private httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };
  private httpSubscription: Subscription;

  constructor(private http: HttpClient) {
    this.setupHttpInternetMonitor();
  }

  private setupHttpInternetMonitor(): void {
    this.httpSubscription = interval(this.monitoringInterval)
      .pipe(
        switchMap(() =>
          this.http.head(this.internetCheckUrl, this.httpOptions).pipe(
            catchError(() => {
              this.internetConnectionSubject.next(false);
              return [];
            })
          )
        )
      )
      .subscribe(() => {
        this.internetConnectionSubject.next(true);
      });
  }

  public hasInternetConnection(): Observable<boolean> {
    return this.internetConnection$;
  }

  ngOnDestroy() {
    if (this.httpSubscription) {
      this.httpSubscription.unsubscribe();
    }
  }
}
